import {BaseSelectFiller} from "./BaseSelectFiller";
import React from "react";

export const FreeAutocompleteSelectFiller = ({content, setFieldValue}) => <BaseSelectFiller content={content}
                                                                                        setFieldValue={setFieldValue}
/>